<template>
    <div class="GroupsComponent DataTables">


        {{ lang.infotext_1 }}
        <br><br>
        <div :id="id"></div>
        <ContextMenuComponent :menu="menu" :id="name"></ContextMenuComponent>


    </div>
</template>
<script>

//import {$, jQuery} from 'jquery'
//datatable
var $ = require('jquery');
var jQuery = $
window.$ = $
window.jQuery = $
var jquery = $;
import 'bootstrap-vue/dist/bootstrap-vue.css'
//var dt_extras = [
require("datatables.net");
require("datatables.net-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-select-bs4");
require("datatables.net-keytable");
// require("datatables.net-buttons-bs4");
// require("@/components/shared/DataTables/jszip.min.js");
// var pdfMake =        require("pdfmake/build/pdfmake");
// var pdfFonts =        require("pdfmake/build/vfs_fonts");
// require("@/components/shared/DataTables/buttons.html5.min.js");
// require("@/components/shared/DataTables/buttons.print.min.js");
// require("@/components/shared/DataTables/buttons.colVis.min.js");
//];

import 'datatables.net-select-bs4/css/select.bootstrap4.min.css'

import 'datatables.net-keytable-bs4/css/keyTable.bootstrap4.min.css'

//pdfMake.vfs = pdfFonts.pdfMake.vfs;


//import LoaderComponent from "@/components/shared/LoaderComponent"
import ContextMenuComponent from "@/components/shared/ContextMenuComponent"
import { mapGetters } from 'vuex'


export default {
    name: "GroupsComponent",
    props: {
        lang: Object,

    },
    components: {
        ContextMenuComponent
    },
    data() {
        return {
            name: "GroupsComponent",
            id: "tableplace_" + this._uid,
            groups: [],
            contextMenu: {},
            //list of items in the context menu
            menu: [
                { id: "Edit", text: this.lang.contextmenu_text_Edit },
                { id: "Delete", text: this.lang.contextmenu_text_Delete },
            ],

        }
    },
    computed: {

        ...mapGetters({


        }),

        reloadedAfterAction() {
            return this.$store.getters.reloadedAfterAction;
        },
        variant() {
            if (this.$store.getters.s_skinVariant == "dark") {
                return "light";
            } else {
                return "dark";
            }

        }
    },


    created() {




    },
    watch: {

        reloadedAfterAction: function (newValue) {

            if (newValue.name == this.name) {
                if (newValue.status == true) {

                    this.getGroups(this);

                    newValue.status = false;
                    newValue.name = "";
                    this.$store.dispatch("reloadAfterAction", newValue);
                }
            }
        }


    },
    updated() {


    },
    created: function () {

        
        this.getGroups();


    },
    methods: {

        getGroups() {

            let _vue = this;

            this.$store.dispatch(_vue.$store.getters.sectionPrefix + "_getGroups")
                .then(function (result) {

                    console.log(result.data)

                    if (result.status == "OK") {

                        if (result.data != null) {

                            _vue.groups = result.data;
                            _vue.buildTable();

                        }
                    }




                })
        },

        buildTable() {


            var tableplace = document.getElementById("tableplace_" + this._uid);
            if (tableplace == null) {
                return;
            }
            while (tableplace.firstChild) {
                tableplace.removeChild(tableplace.firstChild);
            }

            for (let i = 0, lei = this.groups.length; i < lei; i++) {

                this.groups[i].actions = "";


            }



            var place = document.createElement("table");
            place.setAttribute("id", "place" + this._uid);
            place.setAttribute("class", "table table-striped table-bordered");
            place.setAttribute("style", "width:100%;");
            tableplace.appendChild(place)

            var tr1 = document.createElement("tr");
            tr1.setAttribute("class", "cellHeader");
            var thead = document.createElement("thead");
            thead.appendChild(tr1);
            place.appendChild(thead);

            var tr2 = document.createElement("tr");
            tr2.setAttribute("class", "cellFooter");
            var tfoot = document.createElement("tfoot");
            tfoot.appendChild(tr2);
            place.appendChild(tfoot);



            var columnDefs = [];

            let columns = [
                {
                    name: "Id",
                    alignInColumn: "left",

                },
                {
                    name: this.lang.table_header_GroupName,
                    alignInColumn: "left",
                },
                
                {
                    name: this.lang.table_header_Actions,
                    alignInColumn: "left",
                }
            ]

            let cols = [
                { "data": "groupId" },
                { "data": "groupName" },
                { "data": "actions" },

            ]

            let _vue = this;

            var len = columns.length;

            for (let i = 0; i < len; i++) {



                var el = {};

                el = {
                    targets: i,
                    className: '_dt-body-' + columns[i].alignInColumn,
                    render: function (data, type, row, meta) {
                        
                        if (data == null) {
                            data = "";
                        }

                        data = $.fn.dataTable.render.text().display(data);
                        if (data.display != undefined) {
                            data.display = $.fn.dataTable.render.text().display(data.display);
                        }


                        if (meta.col == 0) {

                            return data
                        } else if (meta.col == 1) {

                            let variant = "orange";
                            if (data == "Admins") {
                                variant = "danger";
                            }
                            
                            return "<b-badge class='badge badge-" + variant + "'>" + data + "</b-badge> ";
                                                   

                        } else if (meta.col == 2) {

                            let disabled = "";
                            if (row.groupName == "All" || row.groupName == "Admins") {
                                disabled = "disabled";
                            }



                            let str = "<button  class=\"btn btn-secondary btn-sm btn-" + _vue.variant + " button_action_edit_group\" " + disabled + " id=\"button_confirm_group_" + row.groupId + "\" >" + _vue.lang.button_Edit + "</button>";
                            str += "<button   class=\"btn btn-secondary btn-sm btn-" + _vue.variant + " button_action_delete_group\" " + disabled + " id=\"button_delete_group_" + row.groupId + "\" >" + _vue.lang.button_Delete + "</button>";

                            return str;
                        }


                    }
                }



                columnDefs.push(el);



                var th1 = document.createElement("th");
                var th2 = document.createElement("th");
                tr1.appendChild(th1);
                tr2.appendChild(th2);
                //var p = document.createElement("p");
                //th.appendChild(p);

                var tx = document.createTextNode(columns[i].name)
                th1.appendChild(tx);

            }




            var json = {};


            json.keys = false;
            json.data = this.groups;
            json.myColumnFormats = columns;
            json.colReorder = false;
            json.lengthMenu = [25];
            json.order = [[1, "asc"]];
            json.select = false;/*{
                  style: 'os',
                  blurable: true
              }*/

            json.columns = cols;
            json.paging = false;
            json.columnDefs = columnDefs;

            json.dom = '<f<t>ip>';
            json.initComplete = function () {



            }
            json.fnDrawCallback = function (oSettings) {

                _vue.buildContextMenu();
            }



            if ($.fn.dataTable.isDataTable('#place' + this._uid)) {
                this.mainTable.destroy();

            }

            this.mainTable = $('#place' + this._uid).DataTable(json);
            this.mainTable.columns.adjust().draw();
            //columnDefs.push(this.mainTable);

            //hide first column in table
            this.mainTable.column(0).visible(false);

            //search input change view
            var searchplace = document.getElementById("place" + this._uid + "_filter").firstChild

            while (searchplace.firstChild) {

                if (searchplace.firstChild.textContent == "Search:") {
                    searchplace.removeChild(searchplace.firstChild);
                    break;
                }

            }


            searchplace.firstChild.setAttribute("placeholder", "Enter search words")
            searchplace.firstChild.setAttribute("class", "form-control form-control-sm");
            searchplace.firstChild.addEventListener("input", function (evt) {

                _vue.$store.dispatch("setFilteredData", evt.target.value);

            })



            let buttons_action_props = document.getElementsByClassName('button_action_edit_group');


            for (var i = 0; i < buttons_action_props.length; i++) {
                buttons_action_props[i].addEventListener('click', function (vue) {

                    var tr = $(this).closest('tr');
                    var row = _vue.mainTable.row(tr);

                    var data = row.data();

                    _vue.updateGroup(data);



                }, false);
            }



            let buttons_action_delete = document.getElementsByClassName('button_action_delete_group');


            for (var i = 0; i < buttons_action_delete.length; i++) {
                buttons_action_delete[i].addEventListener('click', function (vue) {




                    var tr = $(this).closest('tr');
                    var row = _vue.mainTable.row(tr);

                    var data = row.data();

                    _vue.deleteGroup(data);





                }, false);
            }







        },
        updateGroup(_data) {

            this.$store.commit("CREATEGROUPFORM", _data);
            
            let _vue = this;

            let funcYes = function (e) {

                let form = _vue.$store.getters.createGroupForm;

                if (form.groupName == "") {

                    let obj = {
                        text: _vue.lang.alert_error_GroupName,
                        time: 15,
                        type: "danger"
                    }
                    _vue.$store.dispatch("displayFooterAlert", obj);

                    return;
                }

                let alert_success_UpdateGroup = _vue.lang.alert_success_UpdateGroup;
                let alert_error_UpdateGroup = _vue.lang.alert_error_UpdateGroup;

                let obj = {
                    groupId: _data.groupId,
                    groupName: form.groupName,
                    permissions: form.permissions
                }

                _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_updateGroup", obj)
                    .then(function (result) {

                        console.log(result)

                        if (result.status == "OK") {
                            if (result.data != null) {

                                
                                let obj = {
                                    text: alert_success_UpdateGroup,
                                    time: 10,
                                    type: "success"
                                }

                                _vue.$store.dispatch("displayFooterAlert", obj)

                                //reload table
                                const reloadObj = {
                                    status: true,
                                    name: "GroupsComponent"
                                }
                                _vue.$store.dispatch("reloadAfterAction", reloadObj);
                            } else {
                                let obj = {
                                    text: alert_error_UpdateGroup + ": " + result.message,
                                    time: 15,
                                    type: "danger"
                                }

                                _vue.$store.dispatch("displayFooterAlert", obj)
                            }
                        } else {
                            let obj = {
                                text: alert_error_UpdateGroup + ": " + result.message,
                                time: 15,
                                type: "danger"
                            }

                            _vue.$store.dispatch("displayFooterAlert", obj)
                        }


                    })

            }

            var obj = {

                text: "",
                type: "update_group",
                buttons: 2,
                size: "lm",
                lang: this.lang.modal_UpdateGroup,
                funcNo: "",
                funcYes: funcYes
            };
            this.$store.dispatch("showModalComponent", obj);

        },
        deleteGroup(_data) {

            let _vue = this;

            let alert_success_DeleteGroup = _vue.lang.alert_success_DeleteGroup;
            let alert_error_DeleteGroup = _vue.lang.alert_error_DeleteGroup;
            
            let groupId = _data.groupId;

            let deleteGroup = function (_vue) {
                
                let obj = {
                    groupId: groupId
                }
                

                _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_deleteGroup", obj)
                    .then(function (result) {
                        
                        console.log(result.data)
                        if (result.status == "OK") {
                            
                        

                            if (result.data != null) {

                                let obj = {
                                    text: alert_success_DeleteGroup,
                                    time: 10,
                                    type: "success"
                                }
                                _vue.$store.dispatch("displayFooterAlert", obj)


                                const reloadObj = {
                                    status: true,
                                    name: "GroupsComponent"
                                }
                                _vue.$store.dispatch("reloadAfterAction", reloadObj);

                            } else {
                                
                                let obj = {
                                    text: alert_error_DeleteGroup + " " + result.message,
                                    time: 15,
                                    type: "danger"
                                }
                                _vue.$store.dispatch("displayFooterAlert", obj)
                            }

                        } else {
                            
                            let obj = {
                                text: alert_error_DeleteGroup + " " + result.message,
                                time: 15, 
                                type: "danger"
                            }
                            _vue.$store.dispatch("displayFooterAlert", obj)
                            
                        }

                    })
            }
console.log(this.lang)
            var obj = {
                title: this.lang.alert_TitleDelete,
                text: this.lang.alert_TextDelete,
                type: "sure",
                buttons: 2,
                size: "sm",
                funcNo: "",
                funcYes: deleteGroup

            }
            this.$store.dispatch("showAlert", obj);
        },
        buildContextMenu() {
            

            var _vue = this;

            //context-menu
            var tableid = $("#place" + this._uid);

            $("#place" + this._uid + " tbody tr")
                .on("contextmenu", function (e) {

                    let tr = $(this).closest('tr');
                    let row = _vue.mainTable.row(tr);

                    let data = row.data();

                    _vue.contextMenu.row = data



                    //methods in table component
                    let updateGroup = _vue.updateGroup;
                    let deleteGroup = _vue.deleteGroup;

                    _vue.contextMenu.funcAction = function (_vue, action) {

                        //calling component methods depending on the context menu item clicked
                        if (action == "Edit") {
                            updateGroup(data);
                        }
                        if (action == "Delete") {
                            deleteGroup(data);
                        }


                        return true;
                    }

                    var height = tableid.height();

                    var offsetX = tableid.offset().left;
                    var offsetY = tableid.offset().top;

                    var top = e.clientY - offsetY + 100;
                    var left = e.clientX - offsetX + 10;


                    $("#context-menu-" + _vue.name).css({
                        display: "block",
                        top: top,
                        left: left
                    });
                    return false; //blocks default Webbrowser right click menu
                })
                .on("click", function () {

                    $("context-menu-" + _vue.name).hide();
                });

            $("#context-menu-" + _vue.name + " a").on("click", function () {

                $(this)
                    .parent()
                    .hide();
            });
            document.addEventListener('click', function (e) {
                let clickInside = e.target.closest("#context-menu-" + _vue.name);

                if (clickInside == null) {

                    let contextMenu = document.getElementById("context-menu-" + _vue.name);
                    if (contextMenu != null) {
                        contextMenu.setAttribute('style', 'display:none');
                    }

                }
            });
            //context-menu
        }
    }


}
</script>
<style lang="scss">
.GroupsComponent {

    table {
        width: 100%;
        font-size: 0.75rem;

    }

    table th {
        padding: 2px !important;

    }

    .table thead th {
        vertical-align: top;
        border-bottom: 3px solid;
        padding-left: 15px;
    }

    table td {
        padding: 2px !important;
        padding-left: 15px;
    }

    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }

    table.dataTable thead th p {
        margin-right: 20px;
    }

    .progress {
        width: 200px;

    }

    .dataTables_filter {
        float: left;
        font-size: 10px;
    }

    .dt-buttons {
        float: left;

        margin-left: 100px;

    }

    .dataTables_filter .form-control-sm,
    .input-group-sm>.form-control {
        padding: 0.1rem 0.1rem;
        font-size: 0.7rem;
        line-height: 1;
        width: 200px;
    }

    .dt-button-collection {

        padding: 0.1rem 0.1rem;
        font-size: 0.7rem;

    }

    .btn {
        padding-top: 1px;
        padding-bottom: 1px;
        padding-left: 3px;
        padding-right: 3px;

        font-size: 0.7rem;

    }

    .form-control {
        padding: 0.075rem 0.75rem;
    }

    .button_action_edit_group {
        margin: 2px 2px 2px 2px;
    }
    .button_action_delete_group {
        margin: 2px 2px 2px 2px;
    }

}

</style>



// WEBPACK FOOTER //
// src/components/shared/GroupsComponent.vue